module.exports = __webpack_public_path__ + "static/media/GridViewOffIcon.fb031604.svg";